var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 10.7719L13.4821 6.26875C13.7154 6.05313 13.7796 5.73125 13.6446 5.45625C13.5071 5.18125 13.2 5.00313 12.8571 5.00313H10.2857V1.00063C10.2857 0.447812 9.775 0 9.14286 0L6.85714 0C6.22571 0 5.71428 0.447812 5.71428 1.00063V5.00375H3.14286C2.80079 5.00375 2.49107 5.18209 2.35536 5.45719C2.22032 5.73228 2.2845 6.05188 2.51943 6.26969L7.37657 10.7728C7.7 11.0719 8.3 11.0719 8.625 10.7719ZM16 13V11C16 10.4478 15.4882 10 14.8571 10C14.2261 10 13.7143 10.4478 13.7143 11V13C13.7143 13.5522 13.2025 14 12.5714 14H3.42857C2.7975 14 2.28571 13.5522 2.28571 13V11C2.28571 10.4478 1.77393 10 1.14286 10C0.511785 10 0 10.4478 0 11V13C0 14.6569 1.535 16 3.42857 16H12.5714C14.465 16 16 14.6562 16 13Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIco);
export default __webpack_public_path__ + "static/media/register_ico.93fb905d12834fdb6b303f4340709072.svg";
export { ForwardRef as ReactComponent };